import React from "react";
import Routes from "./Routes";
import { ThemeProvider } from "@material-ui/styles";
import { CookiesProvider } from "react-cookie";
import ReactGA from "react-ga";
import { useSelector } from "react-redux";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import CookieToolbar from "./components/CookieToolbar/CookieToolbar";
import "./theme/landingPage.css";

ReactGA.initialize("UA-184804437-1");
ReactGA.pageview(window.location.pathname + window.location.search);

export default function App() {
  const theme = useSelector((state) => state.app.theme);

  return (
    <GTMProvider state={{ id: "GTM-53FK9LQ" }}>
      <CookiesProvider>
        <ThemeProvider theme={theme}>
          <Routes />
          <CookieToolbar />
        </ThemeProvider>
      </CookiesProvider>
    </GTMProvider>
  );
}
